var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationUpdatePasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48622 2 2 6.48622 2 12C2 17.5138 6.48622 22 12 22C17.5138 22 22 17.5138 22 12C22 6.48622 17.5138 2 12 2ZM17.589 9.36842L11.198 15.7093C10.8221 16.0852 10.2206 16.1103 9.81955 15.7343L6.43609 12.6516C6.03509 12.2757 6.01003 11.6491 6.3609 11.2481C6.73684 10.8471 7.36341 10.8221 7.76441 11.198L10.4461 13.6541L16.1604 7.93985C16.5614 7.53885 17.188 7.53885 17.589 7.93985C17.99 8.34085 17.99 8.96742 17.589 9.36842Z",
    fill: "#299C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUpdatePasswordIcon);
export default __webpack_public_path__ + "static/media/notification-update-password-icon.38592cb1cbef278c1ec5fa05bda56367.svg";
export { ForwardRef as ReactComponent };